import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { ChargingNetworkWiseActions } from "stores/ChargingNetworkWiseStore/ChargingNetworkWiseAction";
import { CoupanCityActions } from "stores/CoupanCitylistStore/CoupanCityAction";

const mapStateToProps = (state) => {
  return {
    CoupanCityList: state.CoupanCity.CoupanCityList,
    ChargingNetwoekList:state.ChargingNet.ChargingNetwoekList,
    AddCoupanModel:state.CoupanCity.AddCoupanModel,
    isloadingCoupanList:state.CoupanCity.CoupanList.isLoading,
    isloadingChargingn:state.ChargingNet.Chargingn.isLoading
  };
};

const mapDispatchToProps = (dispatch) => bindActionCreators({
  getCoupanCityActions:CoupanCityActions.getCoupanCityActions,
  getChargingNetworkWiseActions:ChargingNetworkWiseActions.getChargingNetworkWiseActions,
  postAddCoupanAction:CoupanCityActions.postAddCoupanModel,
  getCoupanCityDelete:CoupanCityActions.getCoupanCityDeleteActions,
}, dispatch);

const CouponsStore = (Container) =>
  connect(mapStateToProps, mapDispatchToProps)(Container);
export default CouponsStore;
